import {db} from "../base";

import React, {useState} from 'react';
import {Table} from 'antd';
import {collection, getDocs, limit, orderBy, query, startAfter} from "firebase/firestore";
import {useQuery} from '@tanstack/react-query';
import NavBar from "../components/NavBar";
import dayjs from "dayjs"; // Adjust the path to your Firebase config file


const UsersPage = () => {

    const [usersNumber, setUsersNumber] = useState(0);

    const fetchUsers = async ({ pageParam = null }) => {

        const transactionsQuery = pageParam ? query(
            collection(db, "utenti"),
            orderBy("creationTime", "desc"),
            limit(50),
            startAfter(pageParam)
        ): query(
            collection(db, "utenti"),
            orderBy("creationTime", "desc"),
        )

        const querySnapshot = await getDocs(transactionsQuery);

        setUsersNumber(querySnapshot.size)

        return querySnapshot.docs.map(doc => (doc.data()));
    };

    const {
        data,
        isLoading
    } = useQuery({
            queryKey: ['users'],
            queryFn: fetchUsers
        }
    );

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'displayName',
            key: 'displayName',
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
        },
        {
            title: 'Punti',
            dataIndex: 'punti',
            key: 'punti',
            render: (punti) => {
                return punti; // Format the date to a readable string
            }
        },
        {
            title: 'Registrato il',
            dataIndex: 'creationTime',
            key: 'creationTime',
            render: (creationTime) => {
                return dayjs(creationTime).format('DD/MM/YYYY HH:mm:ss');
            }
        },
    ];

    return (
        <>
            <NavBar/>
            <main>
                <h1>Numero totale clienti: {usersNumber}</h1>
                <Table
                    loading={isLoading}
                    columns={columns}
                    dataSource={data}
                    pagination={false} // Disable default pagination
                    rowKey="key"
                />
            </main>
        </>
    );
};

export default UsersPage;

